import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=5168b938&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5168b938')) {
      api.createRecord('5168b938', component.options)
    } else {
      api.reload('5168b938', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=5168b938&", function () {
      api.rerender('5168b938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Switch.vue"
export default component.exports